module.exports = __webpack_public_path__ + "img/7.63bedc7c.jpg";